module.exports = __webpack_public_path__ + "static/media/kids_playing_green.a77927fb.png";